export default __webpack_public_path__ + "static/media/filesconverto.7ea1846f.png";